import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import UserEntity from "../../../../domain/entities/UserEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserDto from "../../../dto/UserDto";

const GetUserByIdApiImpl = async (id: string): Promise<Either<ErrorEntity, UserEntity>> => {
    try {
        const relativeUrl: string = `/users/${id}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = UserDto.fromJSON(response.data);
        return right(parsed)
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default GetUserByIdApiImpl;
